(function(){
  "use strict";
  var KEY = "sf_catalogue_cta_dismiss_until";
  var DISMISS_MS = 30*24*60*60*1000;

  function shouldHide(){
    try {
      var v = localStorage.getItem(KEY);
      return v && Date.now() < parseInt(v,10);
    } catch(e){ return false; }
  }
  function dismiss(){
    try { localStorage.setItem(KEY, Date.now()+DISMISS_MS); } catch(e){}
  }

  document.addEventListener("DOMContentLoaded",function(){
    var box=document.getElementById("sf-catalogue-cta");
    if(!box) return;
    if(shouldHide()) return;
    box.style.display="block";

    var btn=box.querySelector(".sf-close");
    if(btn){
      btn.addEventListener("click",function(e){
        e.preventDefault();
        dismiss();
        box.style.opacity="0";
        setTimeout(function(){box.remove();},200);
      });
    }
  });
})();
